var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"results"},[_c('TitleBreadcrumb'),_c('div',{staticClass:"content-base container"},[_c('ResultList',{attrs:{"show-description":!!_vm.$route?.params?.lottery}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }